<template slot-scope="scope">
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :empty-text="HintMsg"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column
          label="申请者ID"
          align="center"
          show-overflow-tooltip
          width="160"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.userCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请者姓名" align="center" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证" align="center" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.idCard || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请者职位" align="center" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.positionName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.statusName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope" v-if="scope.row.status == '0'">
            <div
              class="table-p"
              style="background: #fe574a"
              @click="handelTurnDown(scope.$index, scope.row)"
            >
              拒绝
            </div>
            <div
              style="background: #409eff "
              class="table-p"
              @click="handelAgree(scope.$index, scope.row, 5)"
            >
              同意
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ThreeWindow
      :dialogVisible="dialogVisible"
      :PopUpTitle="PopUpTitle"
      :type="type"
      @handleCancel="handleCancel"
      @handleVerify="handleVerify"
    ></ThreeWindow>
  </div>
</template>

<script>
import {
  bindAuditAgree, //同意加入企业管理员
  bindAuditRefuse, //拒绝加入企业管理员
} from "../../../../../assets/api/firm/firmCenter";
import ThreeWindow from "./ThreeWindow.vue";
export default {
  props: {
    tableData: {},
    HintMsg: {}, //提示语
  },
  components: { ThreeWindow },
  data() {
    return {
      dialogVisible: false, //提示弹窗
      PopUpTitle: "", //提示弹窗标题
      type: "1", //提醒类型，本页只有删除 1      拒绝2  同意3
      ControlsId: "", // 同意/拒绝id
    };
  },
  computed: {},
  created() {},
  methods: {
    // 拒绝
    handelTurnDown(index, row) {
      if (!this.$checkAction()) return;
      this.$confirmWithScroll("是否拒绝该申请者成为企业管理员？", "拒绝申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            data: {
              id: row.id,
            },
          };
          bindAuditRefuse(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("handleVerify");
            }
          });
        })
        .catch(() => {});
    },
    // 同意
    handelAgree(index, row) {
      if (!this.$checkAction()) return;
      this.$confirmWithScroll("是否通过该申请者成为企业管理员？", "同意申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            data: {
              id: row.id,
            },
          };
          bindAuditAgree(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("handleVerify");
            }
          });
        })
        .catch(() => {});
    },
    // 弹窗 取消
    handleCancel(val) {
      this.dialogVisible = !this.dialogVisible;
    },
    // 弹窗确认
    handleVerify(val) {
      var data = {
        data: {
          id: this.ControlsId,
        },
      };
      if (val == "2") {
        // 拒绝
        bindAuditRefuse(data).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            // 传给父组件刷新数据接口
            this.$emit("handleVerify");
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      } else if (val == "3") {
        // 同意
        bindAuditAgree(data).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            // 传给父组件刷新数据接口
            this.$emit("handleVerify");
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      }
      // val 是type的值 2拒绝 3同意
      this.dialogVisible = !this.dialogVisible;
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}

/* 强制右侧固定列高度与主内容区相同 */
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.table-p {
  display: inline-block;
  width: 64px;
  height: 25px;
  line-height: 25px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  font-weight: 400;
  cursor: pointer;
  margin: auto;
  margin-right: 10px;
  border-radius: 5px;
}

/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(8) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  width: 100%;
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
